export default __webpack_public_path__ + "static/media/warning.d0a9a79d.svg";